import {BaseService} from './baseService.js';
import {Service} from './service.js';

/* 
 * Handles interaction with the user dashboards
 */
export class DashboardService extends BaseService {
	
	constructor() {	
		super();
	}
	
	async getDashboards() {
		var data = await this.makeGETRequest('/api/resource/user-dashboards');		
		return data;
	}	
	
	async getDashboard(dashboardId) {
		var data = await this.makeGETRequest('/api/resource/user-dashboards/' + dashboardId);		
		return data;
	}
	
	async saveDashboard(dashboard, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/user-dashboards/' + dashboard.dashboardId, dashboard);
		} else {
			saved = await this.makePOSTRequest('/api/resource/user-dashboards', dashboard);
		}
		return saved;
	}
	
	async deleteDashboard(dashboardId) {		
		var result = await this.makeDELETERequest('/api/resource/user-dashboards/' + dashboardId);		
		return result;
	}
	
};


